import * as Yup from "yup";
import { BoletagemProdutoSchema } from "../boletagem-produto";
import { BoletagemProdutoAnexoTipo } from "./model";

export class BoletagemProdutoAnexoSchema {
  public static id() {
    return recordShape.id;
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static create() {
    const {
      produto,
      tipo,
    } = recordShape;
    return Yup
      .object()
      .shape({
        produto: produto.required("Produto é obrigatório"),
        tipo: tipo.required("Tipo é obrigatório"),
      });
  }
}

const recordShape = {
  id: Yup
    .number(),
  produto: Yup
    .object()
    .shape({
      id: BoletagemProdutoSchema.id()
        .required("Produto é obrigatório"),
    }),
  tipo: Yup
    .mixed<BoletagemProdutoAnexoTipo>()
    .oneOf(
      Object.values(BoletagemProdutoAnexoTipo),
      `Liberar registro deve ser "${Object.values(BoletagemProdutoAnexoTipo).join('" ou "')}"`
    ),
};
